import { toast } from 'react-toastify';

const runLogout = (navigate) => {
  const token = localStorage.getItem('token');
  const baseUrl = process.env.REACT_APP_BASE_URL;

  localStorage.clear();
  if (token && baseUrl) {
    fetch(`${baseUrl}/login/api/login/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }).catch(() => {});
  }

  toast.success('Logged out. Sign in to open the dashboard.', {
    position: 'top-center',
    autoClose: 1600,
  });
  navigate('/', { replace: true });
};

export const openLogoutPrompt = (navigate) => {
  toast(({ closeToast }) => (
    <div className="krv-logout-card">
      <div className="krv-logout-mark" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
          <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
          <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
        </svg>
      </div>
      <div className="krv-logout-copy">
        <strong>Confirm Logout?</strong>
        <p>You will be signed out and returned to the login page.</p>
      </div>
      <div className="krv-logout-actions">
        <button
          type="button"
          className="krv-logout-stay"
          onClick={(event) => {
            event.stopPropagation();
            closeToast();
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="krv-logout-go"
          onClick={(event) => {
            event.stopPropagation();
            closeToast();
            runLogout(navigate);
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  ), {
    toastId: 'logout-confirm',
    position: 'top-center',
    autoClose: false,
    closeOnClick: false,
    draggable: false,
    closeButton: false,
    icon: false,
    hideProgressBar: true,
    className: 'krv-toast-confirm',
  });
};
